/* eslint-disable prettier/prettier */

import React from 'react';
import PropTypes from 'prop-types';
import { Meteor } from 'meteor/meteor';
import { withTracker } from 'meteor/react-meteor-data';
import { saveAs } from 'file-saver';

import uuid from 'uuid/v1';
import { Bert } from 'meteor/themeteorchef:bert';
import {
  Alert,
  Box,
  Button,
  ButtonGroup,
  Checkbox,
  Chip,
  Divider,
  Fab,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Modal,
  OutlinedInput,
  Paper,
  Select,
  Stack,
  Step,
  Stepper,
  StepLabel,
  styled,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';

import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import HomeIcon from '@mui/icons-material/Home';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import ReplayIcon from '@mui/icons-material/Replay';
import PlagiarismOutlinedIcon from '@mui/icons-material/PlagiarismOutlined';
import { isEmpty } from 'lodash';
import Connectors from '../../../api/Connectors/Connectors';
import Loading from '../Loading';
import useTimeStore from '../ZustandProvider';

const ISLComponentModal = ({
  isLoading,
  listOfProcess,
  openModal,
  setIsLoading,
  setOpenModal,
  setValueToShow,
  valueToShow,
  dataList,
  connectorList,
  outputFormats
}) => {
  const [activeStep, setActiveStep] = React.useState(0);
  const [openViewMap, setOpenViewMap] = React.useState(false);
  const [parameterToShow, setParameterToShow] = React.useState({});
  const layers = useTimeStore(state => state.layers);
  const [importFile, setImportFile] = React.useState(null);
  const [isMapSelected, setIsMapSelected] = React.useState(false);
  const [layerSelected, setLayerSelected] = React.useState('');
  const [tablePage, setTablePage] = React.useState(0);
  const [inputToShow, setInputToShow] = React.useState('');
  const [inputOption, setInputOption] = React.useState('Url');
  const [pageFile, setPageFile] = React.useState(0);
  const [outputFormatSelected, setOutputFormatSelected] = React.useState([]);
  const [activestepnew, setActivestepnew] = React.useState(0);
  const [answerFunction, setAnswerFunction] = React.useState({});
  const steps = 4;
  const stepsProperties = ['Entrada', 'Otras variables', 'Salida', 'Función final'];
  const fileInputRef = React.useRef(null);
  const rowsPerPage = 10;

  const handleChangeTablePage = (event, newPage) => {
    setTablePage(newPage);
  };

  const handleChangeFilePage = (event, newPage) => {
    setPageFile(newPage);
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: '#2A3F90',
      color: theme.palette.common.white
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14
    }
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    },
    '&:last-child td, &:last-child th': {
      border: 0
    }
  }));

  const StyledTable = styled(Table)(() => ({
    border: `1px solid #2A3F90`
  }));

  // const reloadFunction = async (row) => {

  //   let bodyConfiguration = {};
  //   if (valueToShow.type === 'ISL') {
  //     bodyConfiguration = {
  //       disk: 'data3',
  //       guid_function: valueToShow.guid,
  //       udf_selected: valueToShow.path,
  //       variables: row.variables,
  //       get_map: !!(row.output && row.output.map),
  //       alias_process: valueToShow.alias,
  //       explanation_process: valueToShow.description,
  //       // output_format: outputFormatSelected,
  //       force_repeat: true
  //     };
  //   } else if (valueToShow.type === 'Airflow') {
  //     bodyConfiguration = {
  //       function: valueToShow.path,
  //       variables: row.variables
  //     };
  //   }

  //   const response = await fetch(valueToShow.url, {
  //     method: 'POST',
  //     body: JSON.stringify(bodyConfiguration),
  //     headers: { 'Content-Type': 'application/json' },
  //     mode: 'cors',
  //     credentials: 'omit',
  //     referrerPolicy: 'no-referrer'
  //   });
  //   const respuesta = await response.json();
  //   setIsLoading(false);
  //   if (respuesta.status === 'OK') {
  //     setAnswerFunction(respuesta.data);
  //   } else {
  //     Bert.alert(respuesta.data, 'danger');
  //   }
  // };

  const callToBackToDoFunction = async () => {
    const nuevoObjeto = {};
    Object.keys(valueToShow.variables).forEach(key => {
      nuevoObjeto[key] = valueToShow.variables[key].input;
    });

    let bodyConfiguration = {};
    if (valueToShow.type === 'ISL') {
      bodyConfiguration = {
        disk: 'data3',
        guid_function: valueToShow.guid,
        udf_selected: valueToShow.path,
        variables: nuevoObjeto,
        get_map: isMapSelected,
        alias_process: valueToShow.alias,
        explanation_process: valueToShow.description,
        output_format: outputFormatSelected,
      };
    } else if (valueToShow.type === 'Airflow') {
      bodyConfiguration = {
        function: valueToShow.path,
        variables: nuevoObjeto
      };
    }

    const response = await fetch(valueToShow.url, {
      method: 'POST',
      body: JSON.stringify(bodyConfiguration),
      headers: { 'Content-Type': 'application/json' },
      mode: 'cors',
      credentials: 'omit',
      referrerPolicy: 'no-referrer'
    });
    const respuesta = await response.json();
    setIsLoading(false);
    if (respuesta.status === 'OK') {
      setAnswerFunction(respuesta.data);
    } else {
      Bert.alert(respuesta.data, 'danger');
    }
  };

  const handleBack = () => {
    setActivestepnew(prevActiveStep => prevActiveStep - 1);
  };

  const handleChangeInput = (value, key, variable) => {
    setValueToShow(prevState => {
      const newValue = { ...prevState };
      newValue.variables[key] = {
        ...newValue.variables[key],
        input: value,
      };
      if (variable.type === 'String' || variable.type === 'Selector' || variable.type === 'File') {
        return newValue;
      } if (variable.type === 'Number' && !Number.isNaN(value) && value > 0) {
        return newValue;
      }
      return prevState;
    });
  };
  
  const handleDownload = async (file, name) => {
    try {
      const response = await fetch(file);
      const blob = await response.blob();
      saveAs(blob, name);
    } catch (error) {
      console.error('Error downloading the file:', error);
    }
  };

  const handleNext = () => {
    if (activestepnew === steps - 1) {
      setOpenModal(false);
      setActivestepnew(0);
    } else if (activestepnew === 2) {
      setActivestepnew(prevActiveStepNew => prevActiveStepNew + 1);
      setIsLoading(true);
      callToBackToDoFunction();
    } else {
      setActivestepnew(prevActiveStepNew => prevActiveStepNew + 1);
    }
  };

  const loadFileToBack = async (file, key) => {
    if (!file) {
      Bert.alert('Selecciona un archivo primero', 'danger');
      setImportFile('');
      return;
    }
    const formData = new FormData();
    formData.append('file', file);
    formData.append('disc', 'data3');
    try {
      const response = await fetch('https://sd1.d3.ipsilum.com/upload', {
        method: 'POST',
        body: formData,
        mode: 'cors',
        credentials: 'omit',
        referrerPolicy: 'no-referrer'
      });
      const respuesta = await response.json();
      const newValue = { ...valueToShow };
      newValue.variables[key].input = respuesta.data.path;
      setValueToShow(newValue);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const renderInput = (key, variable) => {
    switch (variable.type) {
      case 'String':
      case 'Out':
        return (
          <TextField
            id="outlined-required"
            label={variable.normal_name}
            size="small"
            sx={{ mb: 2 }}
            value={variable.input}
            onChange={event => handleChangeInput(event.target.value, key, variable)}
            InputProps={{
              endAdornment: (
                <Tooltip title={variable.explanation} placement="top">
                  <IconButton style={{ color: '#2A3F90' }}>
                    <HelpOutlineIcon />
                  </IconButton>
                </Tooltip>
              )
            }}
            fullWidth
          />
        );
      case 'File':
        return (
          <>
            <Typography variant="h6">{key}</Typography>
            <Typography variant="body2">{variable.explanation}</Typography>
            <TextField
              id="outlined-required"
              label="Url"
              size="small"
              sx={{ mb: 2 }}
              value={variable.input}
              onChange={event => handleChangeInput(event.target.value, key, variable)}
              // InputProps={{
              //   endAdornment: (
              //     <Tooltip title={variable.explanation} placement="top">
              //       <IconButton style={{ color: '#2A3F90' }}>
              //         <HelpOutlineIcon />
              //       </IconButton>
              //     </Tooltip>
              //   )
              // }}
              fullWidth
            />
            <FormControl fullWidth sx={{ mb: 1 }}>
              <InputLabel id="demo-select-label">Layers</InputLabel>
              <Select
                labelId="demo-select-label"
                id="demo-select"
                label="Layers"
                size="small"
                value={layerSelected}
                onChange={event => {
                  const selectedLayer = layers.find(layer => layer.name === event.target.value);
                  setLayerSelected(selectedLayer.name);
                  handleChangeInput(selectedLayer.url, key, variable);
                }}
              >
                {layers.map(item => (
                  <MenuItem key={item.name} value={item.name}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              fullWidth
              label="Upload file"
              size="small"
              value={importFile ? importFile.name : ''}
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      variant="contained"
                      aria-label="upload"
                      component="label"
                      style={{
                        color: '#2A3F90'
                      }}
                      onClick={() => {
                        fileInputRef.current.click();
                      }}
                    >
                      <PlagiarismOutlinedIcon />
                    </IconButton>
                    <input
                      ref={fileInputRef}
                      type="file"
                      style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                      onChange={event => {
                        setImportFile(event.target.files[0]);
                        loadFileToBack(event.target.files[0], key);
                      }}
                    />
                  </InputAdornment>
                )
              }}
            />
          </>
        );
      case 'Number':
        return (
          <TextField
            id="outlined-required"
            label={variable.normal_name}
            size="small"
            value={variable.input}
            onChange={event => handleChangeInput(event.target.value, key, variable)}
            mb={2}
            fullWidth
          />
        );
      case 'Selector':
        return (
          <Select
            id="outlined-required"
            label={variable.normal_name}
            size="small"
            value={variable.input}
            onChange={event => handleChangeInput(event.target.value, key, variable)}
            fullWidth
          >
            {variable.example.map(item => (
              <MenuItem key={item} value={item}>
                {item}
              </MenuItem>
            ))}
          </Select>
        );
      case 'Map Coordinate':
        return (
          <Box display="flex" flexDirection="row">
            <TextField
              label="Latitud"
              value={variable.input[0]}
              onChange={event => {
                const inputValue = event.target.value;
                const numericValue = inputValue === '' ? NaN : parseFloat(inputValue);
                setValueToShow(prevState => {
                  const newValue = { ...prevState };

                  if (!Number.isNaN(numericValue) && /^[+-]?\d*\.?\d+$/.test(inputValue)) {
                    newValue.variables[key] = {
                      ...newValue.variables[key],
                      input: [numericValue, newValue.variables[key].input[1]],
                    };
                  } else {
                    newValue.variables[key] = {
                      ...newValue.variables[key],
                      input: [inputValue, newValue.variables[key].input[1]],
                    };
                  }
                  return newValue;
                });
              }}
              margin="normal"
              size="small"
              fullWidth
            />
            <TextField
              label="Longitud"
              value={variable.input[1]}
              onChange={event => {
                const inputValue = event.target.value;
                const numericValue = inputValue === '' ? NaN : parseFloat(inputValue);
                setValueToShow(prevState => {
                  const newValue = { ...prevState };
                  if (!Number.isNaN(numericValue) && /^[+-]?\d*\.?\d+$/.test(inputValue)) {
                    newValue.variables[key] = {
                      ...newValue.variables[key],
                      input: [ newValue.variables[key].input[0], numericValue],
                    };
                  } else {
                    newValue.variables[key] = {
                      ...newValue.variables[key],
                      input: [
                        newValue.variables[key].input[0], inputValue],
                    };
                  }
                  return newValue;
                });
              }}
              margin="normal"
              size="small"
              fullWidth
            />
          </Box>
        )
        
      default:
        return (
          <TextField
            id="outlined-required"
            label={variable.normal_name}
            size="small"
            value={variable.input}
            onChange={event => handleChangeInput(event.target.value, key, variable)}
            mb={2}
            fullWidth
          />
        );
    }
  };

  const body = (
    <Box backgroundColor="white" height="100%" width="100%">
      {activeStep === 0 && !isEmpty(valueToShow) && (
        <>
          <Box display="flex" height="10%" width="100%" alignItems="center" mr={5}>
            <Grid container direction="row" justifyContent="space-around">
              <IconButton
                variant="outlined"
                onClick={() => {
                  setActiveStep(0);
                  setActivestepnew(0);
                }}
                sx={{ marginLeft: '16px', color: '#2A3F90' }}
              >
                <HomeIcon />
              </IconButton>
              <Grid item xs={3} justifyContent="space-around">
                <Typography variant="h6" fontWeight="bold">
                  {valueToShow.name}
                </Typography>
              </Grid>
              <Button
                style={{ backgroundColor: '#2A3F90', color: 'white', margin: 0 }}
                onClick={() => {
                  setActiveStep(2);
                  setActivestepnew(0);
                }}
              >
                          Ejecutar
              </Button>
              <Button
                style={{ backgroundColor: '#2A3F90', color: 'white', margin: 0 }}
                onClick={() => {
                  setActiveStep(1);
                  setActivestepnew(0);
                }}
              >
                          Crear
              </Button>
              <IconButton
                variant="outlined"
                onClick={() => {
                  setOpenModal(false);
                  setInputToShow('')
                  setActiveStep(0);
                  setActivestepnew(0);
                  setOutputFormatSelected([])
                }}
                sx={{ marginLeft: '16px', color: '#2A3F90' }}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </Box>
          <Box height="90%" ml={3} mr={3} justifyContent="center">
            {!isEmpty(valueToShow.html) ? (
              <Box height='100%' >
                <iframe
                  title="WebPage"
                  src={valueToShow.html}
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                />
              </Box>
            ): (
              <Typography variant="body1" m={1}>
                {valueToShow.explanation}
              </Typography>
            )}
          </Box>
        </>
      )}
      {activeStep === 1 && !isEmpty(valueToShow) && (
        <>
          <Box display="flex" height="10%" width="100%" alignItems="center" mr={5}>
            <Grid container direction="row" justifyContent="space-around">
              <Grid item xs={1}>
                <IconButton
                  variant="outlined"
                  onClick={() => {
                    setActiveStep(0);
                    setActivestepnew(0);
                  }}
                  sx={{ marginLeft: '16px', color: '#2A3F90' }}
                >
                  <HomeIcon />
                </IconButton>
              </Grid>
              <Grid item xs={3} sx={{ justifyContent: 'space-around', display: 'flex' }}>
                <Typography variant="h6" fontWeight="bold">
                  {valueToShow.name}
                </Typography>
              </Grid>
              <Grid item xs={1}>
                <Button
                  disabled={activestepnew === 0}
                  sx={{
                    color: '#2A3F90'
                  }}
                  onClick={handleBack}
                >
                  Back
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                  <Stepper activeStep={activestepnew} alternativeLabel sx={{ width: '100%' }}>
                    {stepsProperties.map(label => (
                      <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                      </Step>
                    ))}
                  </Stepper>
                </Box>
              </Grid>
              <Grid
                item
                xs={1}
                sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}
              >
                <Button
                  variant="contained"
                  sx={{
                    color: 'white',
                    backgroundColor: '#2A3F90'
                  }}
                  onClick={handleNext}
                >
                  {activestepnew === steps - 1 ? 'Finish' : 'Next'}
                </Button>
                <IconButton
                  variant="outlined"
                  onClick={() => {
                    setOpenModal(false);
                    setActivestepnew(0);
                    setInputToShow('')
                    setOutputFormatSelected([])

                  }}
                  sx={{ marginLeft: '16px', color: '#2A3F90' }}
                >
                  <CloseIcon />
                </IconButton>
              </Grid>
            </Grid>
          </Box>
          <Box height="90%" width="100%" ml={3} mr={3} justifyContent="center">
            <Box ml={3} mr={3}>
              {activestepnew === 0 && !isEmpty(valueToShow) && (
                <Box ml={3} mr={3}>
                  <Typography variant="h6" fontWeight="bold" m={1}>
                    Variables de entrada
                  </Typography>
                  <Grid container direction="row" wrap="nowrap" spacing={2}>
                    <Grid item xs={2}>
                      <Grid container direction="column">
                        <Stack direction="column" justifyContent="space-around" spacing={1}>
                          {Object.keys(valueToShow.variables).map(key => (
                            <div key={key}>
                              {(valueToShow.variables[key].type === ('File' )|| valueToShow.variables[key].type === ('Connection'))&& (
                                <Fab
                                  key={key}
                                  onClick={() => {
                                    setLayerSelected('');
                                    setInputOption('Url');
                                    setInputToShow(key);
                                  }}
                                  size="small"
                                  style={{
                                    color: 'white',
                                    backgroundColor: '#2A3F90',
                                    boxShadow: 'none',
                                    direction: 'row',
                                    justifyContent: 'space-between'
                                  }}
                                  variant="extended"
                                  fullwidth
                                >
                                  {valueToShow.variables[key].normal_name}
                                  <CheckCircleOutlineRoundedIcon
                                    key={uuid()}
                                    color={
                                      isEmpty(valueToShow.variables[key].input)
                                        ? 'error'
                                        : 'success'
                                    }
                                  />
                                </Fab>
                              )}
                            </div>
                          ))}
                        </Stack>
                      </Grid>
                    </Grid>
                    <Grid item xs={1} />
                    <Grid item xs={6}>
                      {!isEmpty(inputToShow) && (
                        <>
                          <Typography variant="h6">
                            {valueToShow.variables[inputToShow].normal_name}
                          </Typography>
                          <Typography variant="body2">
                            {valueToShow.variables[inputToShow].explanation}
                          </Typography>
                          {valueToShow.variables[inputToShow].type === 'File' && (
                            <>
                              <Box
                                sx={{
                                  display: 'flex',
                                  '& > *': {
                                    m: 1
                                  }
                                }}
                              >
                                <ButtonGroup
                                  variant="contained"
                                  aria-label="outlined primary button group"
                                >
                                  <Button
                                    style={{
                                      fontSize: 11,
                                      backgroundColor:
                                        inputOption === 'Url' ? '#2A3F90' : 'inherit',
                                      color: inputOption === 'Url' ? 'white' : 'inherit',
                                      size: 'small',
                                      border: '1px solid #2A3F90'
                                    }}
                                    onClick={() => {
                                      setInputOption('Url');
                                    }}
                                    disabled={inputOption === 'Url'}
                                  >
                                    Url
                                  </Button>
                                  <Button
                                    style={{
                                      fontSize: 11,
                                      backgroundColor:
                                        inputOption === 'Layer' ? '#2A3F90' : 'inherit',
                                      color: inputOption === 'Layer' ? 'white' : 'inherit',
                                      size: 'small',
                                      border: '1px solid #2A3F90'
                                    }}
                                    onClick={() => {
                                      setInputOption('Layer');
                                    }}
                                    disabled={inputOption === 'Layer'}
                                  >
                                    Layer
                                  </Button>
                                  <Button
                                    style={{
                                      fontSize: 11,
                                      backgroundColor:
                                        inputOption === 'input' ? '#2A3F90' : 'inherit',
                                      color: inputOption === 'input' ? 'white' : 'inherit',
                                      size: 'small',
                                      border: '1px solid #2A3F90'
                                    }}
                                    onClick={() => {
                                      setInputOption('input');
                                    }}
                                    disabled={inputOption === 'input'}
                                  >
                                    Upload file
                                  </Button>
                                  <Button
                                    style={{
                                      fontSize: 11,
                                      backgroundColor:
                                        inputOption === 'server' ? '#2A3F90' : 'inherit',
                                      color: inputOption === 'server' ? 'white' : 'inherit',
                                      size: 'small',
                                      border: '1px solid #2A3F90'
                                    }}
                                    onClick={() => {
                                      setInputOption('server');
                                    }}
                                    disabled={inputOption === 'server'}
                                  >
                                    File of server
                                  </Button>
                                </ButtonGroup>
                              </Box>
                              {inputOption === 'Url' && (
                                <TextField
                                  id="outlined-required"
                                  label="Url"
                                  size="small"
                                  sx={{ mb: 2 }}
                                  value={valueToShow.variables[inputToShow].input}
                                  onChange={event =>
                                    handleChangeInput(
                                      event.target.value,
                                      inputToShow,
                                      valueToShow.variables[inputToShow]
                                    )
                                  }
                                  fullWidth
                                />
                              )}
                              {inputOption === 'Layer' && (
                                <FormControl fullWidth sx={{ mb: 1 }}>
                                  <InputLabel id="demo-select-label">Layers</InputLabel>
                                  <Select
                                    labelId="demo-select-label"
                                    id="demo-select"
                                    label="Layers"
                                    size="small"
                                    value={layerSelected}
                                    onChange={event => {
                                      const selectedLayer = layers.find(
                                        layer => layer.name === event.target.value
                                      );
                                      setLayerSelected(selectedLayer.name);
                                      handleChangeInput(
                                        selectedLayer.url,
                                        inputToShow,
                                        valueToShow.variables[inputToShow]
                                      );
                                    }}
                                  >
                                    {layers.map(item => (
                                      <MenuItem key={item.name} value={item.name}>
                                        {item.name}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              )}
                              {inputOption === 'input' && (
                                <TextField
                                  fullWidth
                                  label="Upload file"
                                  size="small"
                                  value={importFile ? importFile.name : ''}
                                  InputProps={{
                                    readOnly: true,
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <IconButton
                                          variant="contained"
                                          aria-label="upload"
                                          component="label"
                                          style={{
                                            color: '#2A3F90'
                                          }}
                                          onClick={() => {
                                            fileInputRef.current.click();
                                          }}
                                        >
                                          <PlagiarismOutlinedIcon />
                                        </IconButton>
                                        <input
                                          ref={fileInputRef}
                                          type="file"
                                          style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                                          onChange={event => {
                                            setImportFile(event.target.files[0]);
                                            loadFileToBack(event.target.files[0], inputToShow);
                                          }}
                                        />
                                      </InputAdornment>
                                    )
                                  }}
                                />
                              )}
                              {inputOption === 'server' && (
                                <Box
                                  component="form"
                                  sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    width: '100%',
                                    mb: 2
                                  }}
                                  noValidate
                                  autoComplete="off"
                                >
                                  {!isEmpty(dataList) && (
                                    <>
                                      <Box sx={{ width: '100%', mb: 2 }}>
                                        <TableContainer component={Paper}>
                                          <StyledTable
                                            aria-label="customized table"
                                            size="small"
                                            stickyHeader
                                          >
                                            <TableHead>
                                              <TableRow>
                                                <StyledTableCell>Server files</StyledTableCell>
                                                <StyledTableCell>Name</StyledTableCell>
                                                <StyledTableCell>Url</StyledTableCell>
                                              </TableRow>
                                            </TableHead>
                                            <TableBody>
                                              {dataList
                                                .slice(
                                                  tablePage * rowsPerPage,
                                                  tablePage * rowsPerPage + rowsPerPage
                                                )
                                                .map(row => (
                                                  <StyledTableRow key={row.data_name}>
                                                    {valueToShow.variables[inputToShow].input ===
                                                    row.data_value ? (
                                                        <IconButton
                                                          size="small"
                                                          aria-label="centrar"
                                                          style={{ color: '#2A3F90' }}
                                                        >
                                                          <RadioButtonCheckedIcon />
                                                        </IconButton>
                                                      ) : (
                                                        <IconButton
                                                          size="small"
                                                          aria-label="centrar"
                                                          style={{ color: '#2A3F90' }}
                                                          onClick={() => {
                                                            handleChangeInput(
                                                              row.data_value,
                                                              inputToShow,
                                                              valueToShow.variables[inputToShow]
                                                            );
                                                          }}
                                                        >
                                                          <RadioButtonUncheckedIcon />
                                                        </IconButton>
                                                      )}
                                                    <StyledTableCell component="th" scope="row">
                                                      {row.data_name}
                                                    </StyledTableCell>
                                                    <StyledTableCell component="th" scope="row">
                                                      {row.data_value}
                                                    </StyledTableCell>
                                                  </StyledTableRow>
                                                ))}
                                            </TableBody>
                                          </StyledTable>
                                        </TableContainer>
                                      </Box>
                                      <Box sx={{ width: '100%' }}>
                                        <TablePagination
                                          rowsPerPageOptions={[10]}
                                          component="div"
                                          count={dataList.length}
                                          rowsPerPage={rowsPerPage}
                                          page={pageFile}
                                          onPageChange={handleChangeFilePage}
                                        />
                                      </Box>
                                    </>
                                  )}
                                </Box>
                              )}
                            </>
                          )}
                          {valueToShow.variables[inputToShow].type === 'Connection' && !isEmpty(connectorList) && (
                            <FormControl fullWidth sx={{ mb: 1 }}>
                              <InputLabel id="demo-select-label">DataBase</InputLabel>
                              <Select
                                labelId="demo-select-label"
                                id="demo-select"
                                label="DataBase"
                                size="small"
                                value={valueToShow.variables[inputToShow] ? valueToShow.variables[inputToShow].input.name : ''}
                                onChange={event => {
                                  const selectedConnection = connectorList.find(
                                    item => item.name === event.target.value
                                  );
                                  handleChangeInput(
                                    selectedConnection,
                                    inputToShow,
                                    valueToShow.variables[inputToShow]
                                  );
                                }}
                              >
                                {connectorList.map(item => (
                                  <MenuItem key={item.name} value={item.name}>
                                    {item.name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          
                          )} 
                        </>
                      )}
                    </Grid>
                    <Grid item xs={3} />
                  </Grid>
                </Box>
              )}
              {activestepnew === 1 && (
                <>
                  <Box width="40%" m={3} display="flex" flexDirection="column">
                    <Typography variant="body2" mb={2}>
                      Variables:
                    </Typography>
                    {Object.keys(valueToShow.variables).map(key => (
                      <React.Fragment key={key}>
                        {(valueToShow.variables[key].optional === false &&
                          valueToShow.variables[key].type !== ('File' || 'Out')) && valueToShow.variables[key].type !== ('Connection') && (
                          <Box mb={2}>{renderInput(key, valueToShow.variables[key])}</Box>
                        )}
                      </React.Fragment>
                    ))}
                  </Box>
                  <Box width="40%" m={3} display="flex" flexDirection="column">
                    <Typography variant="body2" mb={2}>
                      Variables opcionales:
                    </Typography>
                    <TextField
                      id="outlined-required"
                      label="Name"
                      size="small"
                      sx={{ mb: 2 }}
                      value={valueToShow.alias}
                      onChange={event =>
                        setValueToShow({ ...valueToShow, alias: event.target.value })
                      }
                      fullWidth
                    />
                    <TextField
                      id="outlined-required"
                      label="Explanation"
                      size="small"
                      sx={{ mb: 2 }}
                      value={valueToShow.description}
                      onChange={event =>
                        setValueToShow({ ...valueToShow, description: event.target.value })
                      }
                      fullWidth
                    />
                    {Object.keys(valueToShow.variables).map(key => (
                      <React.Fragment key={key}>
                        {valueToShow.variables[key].optional === true &&
                          valueToShow.variables[key].type !== ('File' || 'Out') && (
                          <Box mb={2}>{renderInput(key, valueToShow.variables[key])}</Box>
                        )}
                      </React.Fragment>
                    ))}
                  </Box>
                </>
              )}
              {activestepnew === 2 && (
                <>
                  <Box ml={3} mr={3}>
                    <Typography variant="h6" fontWeight="bold" m={1}>
                      Archivos de salida
                    </Typography>
                    <Box width="40%" m={2} display="flex" flexDirection="column">
                      {Object.keys(valueToShow.variables).map(key => (
                        <>
                          {valueToShow.variables[key].type === 'Out' && (
                            <Box mb={2} key={key}>
                              {renderInput(key, valueToShow.variables[key])}
                            </Box>
                          )}
                        </>
                      ))}
                    </Box>
                    {!isEmpty(outputFormats) && (
                      <Box display="row" fullWidth mb={2}>
                        <FormControl fullWidth>
                          <InputLabel>Formatos de salida</InputLabel>
                          <Select
                            label="Formatos de salida"
                            labelId="demo-multiple-chip-label"
                            size="small"
                            multiple
                            value={outputFormatSelected.map(format => outputFormats.find(item => item.format === format).name)}
                            onChange={event => {
                              const selectedNames = event.target.value; 
                              const selectedFormats = outputFormats
                                .filter(item => selectedNames.includes(item.name))
                                .map(item => item.format);
                              setOutputFormatSelected(selectedFormats);
                            }}
                            input={<OutlinedInput id="select" label="Formatos de salida" />}
                            renderValue={selected => (
                              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                {selected.map(name => (
                                  <Chip key={name} label={name} />
                                ))}
                              </Box>
                            )}
                          >
                            {outputFormats.map(item => (
                              <MenuItem key={item.name} value={item.name}>
                                {item.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Box>
  
                    )}
                  </Box>
                  {valueToShow.type === 'ISL' && (
                    <Box display="row" justifyContent="space-evenly" fullwidth="true" mb={2}>
                      <Checkbox
                        checked={isMapSelected}
                        onChange={() => {
                          setIsMapSelected(!isMapSelected);
                        }}
                        sx={{
                          color: '#2A3F90',
                          '&.Mui-checked': {
                            color: '#2A3F90'
                          }
                        }}
                        value="isMapSelected"
                      />
                      Mostrar mapa
                    </Box>
                  )}
                </>
              )}
              {activestepnew === 3 && (
                <Box
                  ml={3}
                  mr={3}
                  flexGrow={1}
                  display="flex"
                  flexDirection="column"
                  height="100%"
                  width="95%"
                >
                  {isLoading ? (
                    <Loading />
                  ) : (
                    <>
                      {isMapSelected && !isEmpty(answerFunction.map) && (
                        <>
                          {answerFunction.map === 'None' ? ( 
                            <Alert severity="info">
                            No hay mapa a mostrar
                            </Alert>
                          ) : (
                            <Box mb={2} flexGrow={1} display="flex" flexDirection="column">
                              <Grid container spacing={2} alignItems="center">
                                <Grid item>
                                  <IconButton
                                    onClick={() => {
                                      setOpenViewMap(!openViewMap);
                                    }}
                                  >
                                    {openViewMap ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                                  </IconButton>
                                </Grid>
                                <Grid item>
                                  <Typography variant="body1">Ver mapa</Typography>
                                </Grid>
                                <Grid item xs>
                                  <Divider sx={{ height: 1, backgroundColor: 'grey' }} />
                                </Grid>
                              </Grid>
                              {openViewMap && (
                                <Box
                                  sx={{
                                    flexGrow: 1,
                                    mt: 2,
                                    display: 'flex',
                                    flexDirection: 'column'
                                  }}
                                >
                                  <iframe
                                    title="WebPage"
                                    src={answerFunction.map}
                                    width="auto"
                                    height="80%"
                                    style={{ border: 0 }}
                                  />
                                </Box>
                              )}
                            </Box>
                          )}
                
                        </>
                      )}
                      <Box mb={2} flexGrow={1} display="flex" flexDirection="column">
                        {Object.keys(answerFunction).map(key => (
                          <div key={key}>
                            {(key !== ('map')) && (
                              <>
                                <TextField
                                  id="standard-start-adornment"
                                  sx={{ m: 1 }}
                                  fullWidth
                                  InputProps={{
                                    startAdornment: <InputAdornment position="start">{key.split('_').pop()}</InputAdornment>,
                                    endAdornment:                        <InputAdornment position="end">
                                      <IconButton
                                        variant="contained"
                                        aria-label="upload"
                                        component="label"
                                        style={{
                                          color: '#2A3F90'
                                        }}
                                        onClick={()=> handleDownload(answerFunction[key], key)}

                                      >
                                        <DownloadIcon />
                                      </IconButton>
                                    </InputAdornment>
                                  }}
                                  variant="standard"
                                  value={answerFunction[key]}
                                />
                              </>
                            )}
                          </div>
                        ))}
                      </Box>

                    </>
                  )}
                </Box>
              )}
            </Box>
          </Box>
        </>
      )}
      {activeStep === 2 && !isEmpty(valueToShow) && (
        <>
          <Box display="flex" height="10%" width="100%" alignItems="center" mr={5}>
            <Grid container direction="row" justifyContent="space-around">
              <Grid item xs={1}>
                <IconButton
                  variant="outlined"
                  onClick={() => {
                    setActiveStep(0);
                    setActivestepnew(0);
                  }}
                  sx={{ marginLeft: '16px', color: '#2A3F90' }}
                >
                  <HomeIcon />
                </IconButton>
              </Grid>
              <Grid item xs={3} sx={{ justifyContent: 'space-around', display: 'flex' }}>
                <Typography variant="h6" fontWeight="bold">
                  {valueToShow.name}
                </Typography>
              </Grid>
              <IconButton
                variant="outlined"
                onClick={() => {
                  setOpenModal(false);
                  setInputToShow('')
                  setOutputFormatSelected([])
                  setActiveStep(0);
                  setActivestepnew(0);
                }}
                sx={{ marginLeft: '16px', color: '#2A3F90' }}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </Box>
          <Box height="90%" width="70%" ml={3} mr={3} justifyContent="center">
            <Box ml={3} mr={3}>
              {!isEmpty(listOfProcess) && (
                <>
                  <Box sx={{ width: '100%', mb: 2 }}>
                    <TableContainer component={Paper}>
                      <StyledTable aria-label="customized table" size="small" stickyHeader>
                        <TableHead>
                          <TableRow>
                            <StyledTableCell style={{ minWidth: 'fit-content' }} />
                            <StyledTableCell align="left">Server files</StyledTableCell>
                            <StyledTableCell style={{ minWidth: 'fit-content' }} />
                            <StyledTableCell align="left">Status</StyledTableCell>
                            <StyledTableCell align="left">Reload</StyledTableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {listOfProcess
                            .slice(tablePage * rowsPerPage, tablePage * rowsPerPage + rowsPerPage)
                            .map(row => (
                              <StyledTableRow key={row.alias_process}>
                                {parameterToShow.guid_process === row.guid_process ? (
                                  <IconButton
                                    size="small"
                                    aria-label="centrar"
                                    style={{ color: '#2A3F90' }}
                                  >
                                    <RadioButtonCheckedIcon />
                                  </IconButton>
                                ) : (
                                  <IconButton
                                    size="small"
                                    aria-label="centrar"
                                    style={{ color: '#2A3F90' }}
                                    onClick={() => {
                                      setParameterToShow(row);
                                    }}
                                  >
                                    <RadioButtonUncheckedIcon />
                                  </IconButton>
                                )}
                                <StyledTableCell component="th" scope="row">
                                  {isEmpty(row.alias_process)
                                    ? row.guid_process
                                    : row.alias_process}
                                </StyledTableCell>
                                <StyledTableCell component="th" scope="row">
                                  {row.explanation_process !== null &&
                                    !isEmpty(row.explanation_process) && (
                                    <Tooltip
                                      title={row.explanation_process}
                                      arrow
                                      placement="top"
                                      PopperProps={{
                                        modifiers: [
                                          {
                                            name: 'preventOverflow',
                                            options: {
                                              boundary: 'window'
                                            }
                                          }
                                        ]
                                      }}
                                    >
                                      <IconButton
                                        size="small"
                                        aria-label="centrar"
                                        style={{ color: '#2A3F90' }}
                                      >
                                        <HelpOutlineIcon />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                </StyledTableCell>
                                <StyledTableCell component="th" scope="row">
                                  {isEmpty(row.status)
                                    ? ' '
                                    : row.status}
                                </StyledTableCell>
                                <StyledTableCell component="th" scope="row">
                                  {row.status === 'COMPLETED'
                                    ? (
                                      <IconButton
                                        size="small"
                                        aria-label="centrar"
                                        style={{ color: '#2A3F90' }}
                                        // onClick={()=> reloadFunction(row)}
                                      >
                                        <ReplayIcon />
                                      </IconButton>
                                    )
                                    : ''}
                                </StyledTableCell>
                              </StyledTableRow>
                            ))}
                        </TableBody>
                      </StyledTable>
                    </TableContainer>
                  </Box>
                  <Box sx={{ width: '100%' }}>
                    <TablePagination
                      rowsPerPageOptions={[10]}
                      component="div"
                      count={listOfProcess.length}
                      rowsPerPage={rowsPerPage}
                      page={tablePage}
                      onPageChange={handleChangeTablePage}
                    />
                  </Box>
                  <Button
                    variant="contained"
                    sx={{
                      color: 'white',
                      backgroundColor: '#2A3F90'
                    }}
                    onClick={() => {
                      setActiveStep(3);
                    }}
                  >
                    Ver
                  </Button>
                </>
              )}
            </Box>
          </Box>
        </>
      )}
      {activeStep === 3 && (
        <>
          <Box display="flex" height="10%" width="100%" alignItems="center" mr={5}>
            <Grid container direction="row" justifyContent="space-around">
              <Grid item xs={1}>
                <IconButton
                  variant="outlined"
                  onClick={() => {
                    setActiveStep(0);
                    setActivestepnew(0);
                  }}
                  sx={{ marginLeft: '16px', color: '#2A3F90' }}
                >
                  <HomeIcon />
                </IconButton>
              </Grid>
              <Grid item xs={3} sx={{ justifyContent: 'space-around', display: 'flex' }}>
                <Typography variant="h6" fontWeight="bold">
                  {valueToShow.name}
                </Typography>
              </Grid>
              <IconButton
                variant="outlined"
                onClick={() => {
                  setOpenModal(false);
                  setActiveStep(0);
                  setActivestepnew(0);
                  setInputToShow('')
                  setOutputFormatSelected([])
                }}
                sx={{ marginLeft: '16px', color: '#2A3F90' }}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </Box>
          <Box height="90%" width="100%" ml={3} mr={3} justifyContent="center">
            <Box
              ml={3}
              mr={3}
              flexGrow={1}
              display="flex"
              flexDirection="column"
              height="100%"
              width="95%"
            >
              {isLoading ? (
                <Loading />
              ) : (
                <>
                  <TableContainer component={Paper}>
                    <StyledTable aria-label="customized table" size="small" stickyHeader>
                      <TableHead>
                        <TableRow>
                          <StyledTableCell align="center" justifyContent="center">
                            {isEmpty(parameterToShow.alias_process)
                              ? parameterToShow.guid_process
                              : parameterToShow.alias_process}
                          </StyledTableCell>
                          <StyledTableCell />
                          <StyledTableCell />
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {Object.keys(parameterToShow.output).map(key => (
                          <>
                            {key !== 'map' && (
                              <StyledTableRow
                                key={uuid()}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                              >
                                <StyledTableCell>
                                  {valueToShow.output[key]
                                    ? valueToShow.output[key].normal_name
                                    : key.split('_').pop()}
                                </StyledTableCell>
                                <StyledTableCell>{parameterToShow.output[key]}</StyledTableCell>
                                <StyledTableCell>
                                  <Stack
                                    color="inherit"
                                    size="small"
                                    direction="row"
                                    justifyContent="flex-end"
                                    alignItems="center"
                                    spacing={0}
                                  >
                                    {parameterToShow.output[key] && (
                                      <IconButton
                                        size="small"
                                        aria-label="download"
                                        onClick={()=> handleDownload(parameterToShow.output[key], key)}
                                        sx={{
                                          color: '#2A3F90'
                                        }}
                                      >
                                        <DownloadIcon />
                                      </IconButton>
                                    )}
                                  </Stack>
                                </StyledTableCell>
                              </StyledTableRow>
                            )}
                          </>
                        ))}
                      </TableBody>
                      {/* <TableFooter>
                        <TableRow>
                          <TablePagination
                            rowsPerPageOptions={rowsPerPageOptions}
                            colSpan={contentHeader.length}
                            count={contentTable.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            sx={{ display: 'flex', justifyContent: 'flex-start' }}
                          />
                        </TableRow>
                      </TableFooter> */}
                    </StyledTable>
                  </TableContainer>
                  {!isEmpty(parameterToShow.output.map) && (
                    <>
                      <Box mb={2} flexGrow={1} display="flex" flexDirection="column">
                        <Grid container spacing={2} alignItems="center">
                          <Grid item>
                            <IconButton
                              onClick={() => {
                                setOpenViewMap(!openViewMap);
                              }}
                            >
                              {openViewMap ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                            </IconButton>
                          </Grid>
                          <Grid item>
                            <Typography variant="body1">Ver mapa</Typography>
                          </Grid>
                          <Grid item xs>
                            <Divider sx={{ height: 1, backgroundColor: 'grey' }} />
                          </Grid>
                        </Grid>
                        {openViewMap && (
                          <Box
                            sx={{
                              flexGrow: 1,
                              mt: 2,
                              display: 'flex',
                              flexDirection: 'column'
                            }}
                          >
                            <iframe
                              title="WebPage"
                              src={parameterToShow.output.map}
                              width="auto"
                              height="80%"
                              style={{ border: 0 }}
                            />
                          </Box>
                        )}
                      </Box>
                    </>
                  )}
                </>
              )}
            </Box>
          </Box>
        </>
      )}
    </Box>
  );

  return (
    <>
      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        style={{
          position: 'absolute',
          bgcolor: 'white',
          top: '0%',
          left: '0%'
        }}
      >
        {body}
      </Modal>
    </>
  );
};



export default withTracker(() => {
  const connectionsSub = Meteor.isClient && Meteor.subscribe('telemetryConnections');
  const connectorsSub = Meteor.subscribe('connectors');

  return {
    loading: !connectionsSub.ready() && !connectorsSub.ready(),
    connectorList: Connectors.find({ deleted: { $eq: 'no' }, type: 'PostgreSQL' }).fetch()
  };
})(ISLComponentModal);

ISLComponentModal.defaultProps = {
  isLoading: false,
  outputFormats: []
};
ISLComponentModal.propTypes = {
  isLoading: PropTypes.bool,
  listOfProcess: PropTypes.array.isRequired,
  openModal: PropTypes.bool.isRequired,
  setIsLoading: PropTypes.func.isRequired,
  setOpenModal: PropTypes.func.isRequired,
  setValueToShow: PropTypes.func.isRequired,
  valueToShow: PropTypes.object.isRequired,
  dataList: PropTypes.array.isRequired,
  connectorList: PropTypes.array.isRequired,
  outputFormats: PropTypes.array

};

